var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.976 9.497c.458.454.268.18.573-.122L9.364 6.56c.305-.303 1.165-.677.707-1.131-.458-.455-1.075-.577-1.38-.275L5.543 8.287c-.305.303-.024.755.433 1.21zm-2.298 3.77l-1.99-1.99 4.235-4.232a3.127 3.127 0 00-3.101.765l-2.21 2.194c-1.22 1.211-.438 2.4.782 3.611 1.22 1.213 2.417 1.988 3.638.776l2.209-2.193a3.08 3.08 0 00.73-3.22l-4.293 4.289zm9.914-11.868C12.35.166 11.119-.611 9.878.623L7.63 2.854a3.13 3.13 0 00-.752 3.236l4.42-4.416 1.99 1.989L8.88 8.07a3.183 3.183 0 003.247-.752l2.247-2.232c1.241-1.232.46-2.455-.781-3.687z",
    fill: "#29C1B9"
  })));
}
export default SvgRelation;